export class LoadInvoices {
  static readonly type = '[Invoices] Load invoices';
  constructor(public preserveResults: boolean = false) {}
}

export class DownloadInvoice {
  static readonly type = '[Invoices] Download invoice';
  constructor(public invoiceId: number) {}
}
